import deepmerge from "./deepmerge.helper";
import { ArkosConfig } from "../../types/new-arkos-config";
("ReplaceWithNeededImportsForArkosConfig"); // This will be filled by post build script

const definedArkosConfig = "ReplaceWithDynamicImport"; // This will be filled by post build script

export function isUsingAuthentication() {
  const { authentication } = getArkosConfig();

  return authentication?.mode;
}

export function isAuthenticationEnabled() {
  const { authentication } = getArkosConfig();

  return authentication?.mode && authentication?.enabled !== false;
}

export const defaultArkosConfig: ArkosConfig & { available?: boolean } = {
  welcomeMessage:
    "Welcome to our RESTful API generated by Arkos, find out more about Arkos at www.arkosjs.com",
  port: Number(process.env.CLI_PORT) || Number(process.env.PORT) || 8000,
  host:
    process.env.CLI_HOST ||
    process.env.HOST ||
    (process.env.ARKOS_BUILD !== "true" ? "0.0.0.0" : "127.0.0.1"),
  fileUpload: {
    baseUploadDir: "uploads",
    baseRoute: "/api/uploads",
  },
  routers: {
    strict: false,
  },
  debugging: {
    requests: {
      level: 1,
    },
  },
};

/**
 * Gives access to the underlying current configurations being used by **Arkos** by default and also loaded through `arkos.config.{ts|js}`
 *
 * @returns {ArkosConfig}
 */
export function getArkosConfig(): ArkosConfig {
  return deepmerge(
    defaultArkosConfig,
    typeof definedArkosConfig === "string"
      ? {}
      : (definedArkosConfig as any).default
  );
}
